module.exports = __webpack_public_path__ + "box3.61c04763.png";